/*
this is a UI-only model
it represents an interaction node, corresponding interaction, and an array of settings for that interaction_x_interval
*/

import Interaction from "../interactions/Interaction";
import InteractionNode from "../interactions/InteractionNode";
import CommunicationSet from "./CommunicationSet";
import InteractionIntervalSetting from "./InteractionIntervalSetting";
import Interval from "./Interval";

class SchedulingMatrixRow {
  interaction: Interaction;
  interaction_node: InteractionNode;
  intervalSettings: Array<InteractionIntervalSetting>;
  condition_id: number | null;
  intervalSetID: number;
  ordinal?: number;
  editMode?:boolean;
  intervalSetName?:string|null;
  insertionPoint?: boolean|null;
  addNewInteractionToIntervalSet?:any;
  dragPreview?:boolean
  ref?:any;
  associatedIntervals?: Array<Interval>;
  associatedCommSets?: Array<CommunicationSet>;
  handleDeleteInteraction?: any;


  constructor(
    interaction: Interaction,
    interaction_node: InteractionNode,
    intervalSettings: Array<InteractionIntervalSetting>,
    condition_id: number | null,
    intervalSetID: number,
    ordinal?: number,
    editMode?:boolean,
    intervalSetName?:string|null,
    insertionPoint?:boolean|null,
    addNewInteractionToIntervalSet?:any,
    dragPreview?:boolean,
    ref?:any,
    associatedIntervals?: Array<Interval>,
    associatedCommSets?: Array<CommunicationSet>,
    handleDeleteInteraction?: any

  ) {
    this.interaction = interaction;
    this.interaction_node = interaction_node;
    this.intervalSettings = intervalSettings;
    this.ordinal = ordinal;
    this.condition_id = condition_id;
    this.intervalSetID = intervalSetID;
    this.editMode = editMode;
    this.intervalSetName = intervalSetName;
    this.insertionPoint = insertionPoint;
    this.addNewInteractionToIntervalSet = addNewInteractionToIntervalSet;
    this.dragPreview = dragPreview;
    this.ref = ref    ;
    this.associatedIntervals = associatedIntervals;
    this.associatedCommSets = associatedCommSets
    this.handleDeleteInteraction = handleDeleteInteraction

  }
}

export default SchedulingMatrixRow;
